import { MenuItem as MenuItemMUI } from '@mui/material'
import { styled } from '@mui/system'
import { rgba } from 'polished'

// SC-10999: seletor de empresas (menu da conta e topo do menu lateral).

// A lista rola sozinha para quem tem muitas empresas, sem empurrar
// Configurações e Sair para fora da tela.
export const AccountsList = styled('div')(() => ({
  maxHeight: '360px',
  overflowY: 'auto',
  paddingBottom: 4
}))

// Título de cada bloco ("Multi-empresas", "Suas contas")
export const SectionLabel = styled('p')(({ theme }) => ({
  margin: 0,
  padding: '12px 16px 4px',
  font: 'normal 600 11px/16px Inter, sans-serif',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: theme.palette.neutral[400]
}))

export const SectionDivider = styled('hr')(({ theme }) => ({
  margin: '8px 16px 0',
  border: 0,
  borderTop: `1px dashed ${theme.palette.neutral[700]}`
}))

// Item do seletor. O contexto atual fica destacado com o verde da marca.
export const SwitchItem = styled(MenuItemMUI)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  minWidth: 280,
  maxWidth: 360,
  margin: '2px 8px',
  padding: '8px',
  borderRadius: 8,

  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: rgba(theme.palette.primary.main, 0.1)
  },
  '&.Mui-selected.Mui-focusVisible': {
    backgroundColor: rgba(theme.palette.primary.main, 0.16)
  }
}))

export const GroupIconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size'
})<{ size?: number }>(({ theme, size = 32 }) => ({
  width: `${size}px`,
  height: `${size}px`,
  flexShrink: 0,
  borderRadius: size >= 40 ? '10px' : '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.neutral[300],
  backgroundColor: theme.palette.neutral[800],
  border: `1px solid ${theme.palette.neutral[700]}`
}))
